<template>
  <!-- Vuetify 3 sizes via `size`; width/height props were ignored → default ~40px -->
  <v-avatar
    :size="avatarSize"
    v-bind="$attrs"
  >
    <v-img
      :src="src || srcDefault"
      :lazy-src="srcDefault"
      :max-width="avatarSize"
      :max-height="avatarSize"
      contain
    ></v-img>
  </v-avatar>
</template>

<script>
export default {
  name: 'BasePictureAvatar',

  inheritAttrs: false,

  props: {
    src: {
      type: String,
      default: '',
    },
    srcDefault: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: '',
    },
    height: {
      type: [String, Number],
      default: '',
    },
  },

  computed: {
    avatarSize() {
      const fromWidth = Number(this.width);
      if (Number.isFinite(fromWidth) && fromWidth > 0) {
        return fromWidth;
      }
      const fromHeight = Number(this.height);
      if (Number.isFinite(fromHeight) && fromHeight > 0) {
        return fromHeight;
      }
      return 40;
    },
  },
};
</script>
